<template>
    <button class="action-button" @click.prevent="$emit('click')"><img :src="icon" v-if="icon"><span v-if="label">{{label}}</span></button>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'action-dropdown-item',
    props: {
        label: {
            type: String,
            description: 'Item label',
        },
        icon: {
            type: String,
            description: 'Item icon'
        }
    },
};
</script>

<style scoped lang="scss">
    .action-button {
        display: block;
        min-width: 265px;
        text-align: left;
        border-bottom: 1px solid #F2F2FF;
        padding-bottom: 9px;
        margin-bottom: 8px;
        img {
            width: 18px;
            margin-right: 9px;
        }
        span {
            color: #200033;
            font-size: 16px;
        }
        &:last-child {
            margin-bottom: 0;
            border-bottom: none;
            padding-bottom: 0;
        }
    }
</style>

